if (!customElements.get('slider-component-navigation')) {
  class SliderComponentNavigation extends HTMLElement {
    constructor() {
      super();
      this.selectors = {
        prevBtn: '[btn-prev]',
        nextBtn: '[btn-next]',
      };
      this.init();
      this.updateNavStatus = this.debounce(this.updateNavStatus.bind(this), 500);
      this.handleResize = this.handleResize.bind(this);
    }

    init() {
      this.sliderComponent = document.querySelector(`${this.dataset.id}`);
      if (!this.sliderComponent) return;

      this.sliderList = this.sliderComponent?.querySelector(`#Slider-${this.dataset.section}[data-id="${this.dataset.section}"]`);
      this.sliderBtnPrev = this.sliderComponent?.querySelector(`.slider-buttons [name="previous"]`);
      this.sliderBtnNext = this.sliderComponent?.querySelector(`.slider-buttons [name="next"]`);

      this.nextBtn = this.querySelector(this.selectors.nextBtn);
      this.prevBtn = this.querySelector(this.selectors.prevBtn);

      this.nextBtn?.addEventListener('click', this.onNextClick.bind(this));
      this.prevBtn?.addEventListener('click', this.onPrevClick.bind(this));
      this.sliderList?.addEventListener('scroll', () => {
        this.updateNavStatus();
      });

      window.addEventListener('resize', this.handleResize);
      window.onload = () => {
        this.handleResize();  // run on load
      };
    }

    handleResize() {
      const isDesktop = window.innerWidth >= 749;
      // Example condition to disable/enable buttons - customize as needed:
      if (isDesktop) {
        // Enable or disable buttons on desktop
        if (this.prevBtn) { this.prevBtn.disabled = false; }
        if (this.nextBtn) { this.nextBtn.disabled = false; }
      } else {
        // Enable or disable buttons on mobile
        if (this.prevBtn) { this.prevBtn.disabled = false; }
        if (this.nextBtn) { this.nextBtn.disabled = false; }
      }
      // After enabling/disabling, sync with internal slider button states if needed
      // this.updateNavStatus();
    }

    updateNavStatus() {
      if (!this.prevBtn || !this.nextBtn) return;

      this.prevBtn.disabled = !!this.sliderBtnPrev?.disabled;
      this.nextBtn.disabled = !!this.sliderBtnNext?.disabled;
    }

    // onNextClick() {
    //   this.sliderBtnNext.click();
    //   this.updateNavStatus();
    // }
    //  onPrevClick() {
    //   this.sliderBtnPrev.click();
    //   this.updateNavStatus();
    // }

    onNextClick() {
      this.sliderBtnNext.click();
      requestAnimationFrame(() => this.updateNavStatus());
    }

    onPrevClick() {
      this.sliderBtnPrev.click();
      requestAnimationFrame(() => this.updateNavStatus());
    }

    debounce(func, wait) {
      let timeout;
      return function (...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, args), wait);
      };
    }
  }

  customElements.define('slider-component-navigation', SliderComponentNavigation);
}
